
import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Welcome from './pages/Welcome';

import LoginPage from './pages/Login';
import OrgAdminLoginPage from './pages/OrgAdminLogin';
import SuperAdminLoginPage from './pages/SuperAdminLogin';
import SignupPage from './pages/Signup';
import ForgotPasswordPage from './pages/ForgotPassword';
import MainLayout from './components/layout/MainLayout';
import PublicRoute from './components/PublicRoute';
import PrivateRoute from './components/PrivateRoute';
import { BreadcrumbProvider } from './context/BreadcrumbContext';
import { SidebarProvider } from './context/SidebarContext';
import PermissionRoute from './components/PermissionRoute';

import ResetPasswordPage from './pages/ResetPassword';
import WorkerListPage from './pages/Worker/List';
import WorkerReviewPage from './pages/Worker/Review';
import WorkerCreatePage from './pages/Worker/Create';
import Dashboard from './pages/Dashboard';
// import Shifts from './pages/Shifts';
import Shifts from './pages/OrgShiftMonitoring';
import OrgShiftMonitoringBoardPage from './pages/OrgShiftMonitoringBoard';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import OnboardingPage from './pages/Worker/Onboarding';
import WorkerDetailsPage from './pages/Worker/Details';
import InterviewPage from './pages/Worker/Interview';
import ProfilePage from './pages/Profile';
import FacilitiesListPage from './pages/Facilitiy/List';
import FacilityReviewPage from './pages/Facilitiy/Review';
import FacilityOnboardPage from './pages/Facilitiy/Onboard';
import FacilityDetailsPage from './pages/Facilitiy/Details';
import SearchResultsPage from './pages/SearchResults';
import FacilityDashboard from './pages/FacilityDashboard';
import FacilitySignupFirstPage from './pages/FacilitySignup/FirstStep';
import FacilitySignupSecondPage from './pages/FacilitySignup/SecondStep';
import FacilityProfilePage from './pages/FacilityProfile';
import FacilityShiftCreate from './pages/FacilityShift/Create';
import TestPushNotificationPage from './pages/TestPushNotification';
import UnauthorizedPage from './pages/Unauthorized';
import ContactPage from './pages/Contact';
import UserTypePrivateRoute from './components/UserTypePrivateRoute';
import { FACILITY_USERTYPE, ORG_USERTYPE, ORG_STAFF_USERTYPE, SUPERADMIN_USERTYPE } from './modules/user';
import FacilityShiftList from './pages/FacilityShift/List';
import OngoingShifts from './pages/FacilityShift/OngoingShifts';
import FacilityReport from './pages/FacilityReport';
import FacilityNotification from './pages/FacilityNotification';
import NotificationPage from './pages/Notification';
import Role from './pages/MasterData/Role';
import CancellationReasons from './pages/MasterData/CancellationReasons';
import FacilityType from './pages/MasterData/FacilityType';
import Qualification from './pages/MasterData/Qualification';
import DocumentTypes from './pages/MasterData/DocumentTypes';
import Designation from './pages/MasterData/Designation';
import RoleDocumentTypeMapping from './pages/MasterData/RoleDocumentTypeMapping';
import FacilityTypeDocumentTypeMapping from './pages/MasterData/FacilityTypeDocumentTypeMapping';
import Bank from './pages/MasterData/Bank';
import Config from './pages/MasterData/Config';
import OrgReportAnalysisPage from './pages/OrgReportAnalysis';
import ShiftRequestsPage from './pages/ShiftRequests';
import FacilityShiftRequestsPage from './pages/FacilityShiftRequests';
import WorkerBulkUpload from './pages/Worker/BulkUpload';
import BankForm from './pages/MasterData/BankForm';
import CustomForm from './pages/MasterData/CustomForm/List';
import ManageCustomFormFields from './pages/MasterData/CustomForm/ManageFormFields';
import MasterDataDashboard from './pages/MasterData/Dashboard';
import OrgFacilityInvoices from './pages/OrgFacilityInvoices';
import FacilityInvoice from './pages/FacilityInvoice';
import OrgFacilityPendingShifts from './pages/OrgFacilityPendingShifts';
import SystemRolesPage from './pages/SuperAdmin/SystemRoles';
import SystemModulesPage from './pages/SuperAdmin/SystemModules';
import RoleModuleMappingPage from './pages/SuperAdmin/RoleModuleMapping';
import UserRoleMappingPage from './pages/SuperAdmin/UserRoleMapping';
import SubscriptionsPage from './pages/SuperAdmin/Subscriptions/List';
import CreateSubscriptionPage from './pages/SuperAdmin/Subscriptions/Create';
import SubscriptionDetailPage from './pages/SuperAdmin/Subscriptions/Details';
import EditSubscriptionPage from './pages/SuperAdmin/Subscriptions/Edit';
import OrganizationsPage from './pages/SuperAdmin/Organizations/List';
import OrganizationOverviewPage from './pages/SuperAdmin/Organizations/Overview';
import OrganizationProfileReviewPage from './pages/SuperAdmin/Organizations/ProfileReview';
import OrganizationStaffListPage from './pages/SuperAdmin/Organizations/StaffList';
import OrganizationSubscriptionDetailsPage from './pages/SuperAdmin/Organizations/SubscriptionDetails';
import SubscriptionUpgradePage from './pages/SuperAdmin/Organizations/SubscriptionUpgrade';
import SuperAdminDocumentTypes from './pages/SuperAdmin/MasterData/DocumentTypes';
import SignupFormBuilder from './pages/SuperAdmin/MasterData/SignupForm';
import ContactRequestsPage from './pages/SuperAdmin/ContactRequests';
import SystemRoles from './pages/Organization/AccessControl/SystemRoles';
import RoleMapping from './pages/Organization/AccessControl/RoleMapping';
import StaffManagement from './pages/Organization/StaffManagement';

const router = createBrowserRouter([
  {
    element: <PublicRoute />,
    children: [
      {
        path: '/',
        element: <LoginPage />,
      }, {
        path: '/org-admin',
        element: <OrgAdminLoginPage />,
      }, {
        path: '/super-admin',
        element: <SuperAdminLoginPage />,
      }, {
        path: '/signup',
        element: <SignupPage />,
      }, {
        path: '/forgot-password',
        element: <ForgotPasswordPage />,
      }, {
        path: '/reset-password',
        element: <ResetPasswordPage />,
      }, {
        path: '/facility/signup',
        element: <FacilitySignupFirstPage />,
      }, {
        path: '/facility/signup/file-upload',
        element: <FacilitySignupSecondPage />,
      }, {
        path: '/contact',
        element: <ContactPage />,
      },
    ],
  },
  {
    path: '/unauthorized',
    element: <UnauthorizedPage />
  },
  {
    path: '/welcome',
    element: <Welcome />,
  },
  {
    element: <PrivateRoute />,
    children: [
      {
        element: (
          <BreadcrumbProvider>
            <SidebarProvider>
              <MainLayout />
            </SidebarProvider>
          </BreadcrumbProvider>
        ),
        children: [
          {
            path: '/dashboard',
            element: <Dashboard />,
          },
          {
            element: <UserTypePrivateRoute allowedUserTypes={[SUPERADMIN_USERTYPE]} />,
            children: [
              {
                element: <PermissionRoute moduleSlug="system-roles" />,
                children: [
                  {
                    path: '/super-admin/system-roles',
                    element: <SystemRolesPage />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="system-modules" />,
                children: [
                  {
                    path: '/super-admin/system-modules',
                    element: <SystemModulesPage />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="role-module-mapping" />,
                children: [
                  {
                    path: '/super-admin/role-module-mapping',
                    element: <RoleModuleMappingPage />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="user-management" />,
                children: [
                  {
                    path: '/super-admin/user-role-mapping',
                    element: <UserRoleMappingPage />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="subscriptions" />,
                children: [
                  {
                    path: '/super-admin/subscriptions',
                    element: <SubscriptionsPage />,
                  },
                  {
                    path: '/super-admin/subscriptions/create',
                    element: <CreateSubscriptionPage />,
                  },
                  {
                    path: '/super-admin/subscriptions/:id',
                    element: <SubscriptionDetailPage />,
                  },
                  {
                    path: '/super-admin/subscriptions/:id/edit',
                    element: <EditSubscriptionPage />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="organizations" />,
                children: [
                  {
                    path: '/super-admin/organizations',
                    element: <OrganizationsPage />,
                  },
                  {
                    path: '/super-admin/organizations/:id',
                    element: <OrganizationOverviewPage />,
                  },
                  {
                    path: '/super-admin/organizations/:id/profile',
                    element: <OrganizationProfileReviewPage />,
                  },
                  {
                    path: '/super-admin/organizations/:id/staff',
                    element: <OrganizationStaffListPage />,
                  },
                  {
                    path: '/super-admin/organizations/:id/subscription',
                    element: <OrganizationSubscriptionDetailsPage />,
                  },
                  {
                    path: '/super-admin/organizations/:id/subscription/upgrade',
                    element: <SubscriptionUpgradePage />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="contact-management" />,
                children: [
                  {
                    path: '/super-admin/contact-requests',
                    element: <ContactRequestsPage />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="document-types" />,
                children: [
                  {
                    path: '/super-admin/masterdata/document-types',
                    element: <SuperAdminDocumentTypes />,
                  },
                  {
                    element: <PermissionRoute moduleSlug="signup-form" />,
                    children: [
                      {
                        path: '/super-admin/masterdata/signup-form',
                        element: <SignupFormBuilder />,
                      },
                    ]
                  },
                ]
              },
            ]
          }

          ,{
            element: <UserTypePrivateRoute allowedUserTypes={[ORG_USERTYPE, ORG_STAFF_USERTYPE]} />,
            children: [
              {
                element: <PermissionRoute moduleSlug="worker-management" />,
                children: [
                  {
                    path: '/workers',
                    element: <WorkerListPage />,
                  },
                  {
                    path: '/worker/:id',
                    element: <WorkerReviewPage />,
                  },
                  {
                    path: '/worker/:id/details',
                    element: <WorkerDetailsPage />,
                  },
                  {
                    path: '/worker/:id/onboarding',
                    element: <OnboardingPage />,
                  },
                  {
                    path: '/worker/:id/interview',
                    element: <InterviewPage />,
                  },
                  {
                    path: '/worker/add',
                    element: <WorkerCreatePage />,
                  },
                  {
                    path: '/worker/bulk-upload',
                    element: <WorkerBulkUpload />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="settings" />,
                children: [
                  {
                    path: '/profile',
                    element: <ProfilePage />,
                  },
                  {
                    path: '/settings',
                    element: <Settings />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="facility-management" />,
                children: [
                  {
                    path: '/facilities',
                    element: <FacilitiesListPage />,
                  },
                  {
                    path: '/facility/:id/review',
                    element: <FacilityReviewPage />,
                  },
                  {
                    path: '/facility/:id/onboarding',
                    element: <FacilityOnboardPage />,
                  },
                  {
                    path: '/facility/:id/details',
                    element: <FacilityDetailsPage />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="shift-monitoring" />,
                children: [
                  {
                    path: '/shifts',
                    element: <Shifts />,
                  },
                  {
                    path: '/shifts-board',
                    element: <OrgShiftMonitoringBoardPage />,
                  },
                  {
                    path: '/shift-requests',
                    element: <ShiftRequestsPage />,
                  },
                  {
                    path: '/facility-pending-shifts',
                    element: <OrgFacilityPendingShifts />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="reports" />,
                children: [
                  {
                    path: '/org-report-analysis',
                    element: <OrgReportAnalysisPage />,
                  },
                  {
                    path: '/reports',
                    element: <Reports />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="invoices" />,
                children: [
                  {
                    path: '/facility-invoices',
                    element: <OrgFacilityInvoices />,
                  },
                ]
              },
              {
                element: <PermissionRoute moduleSlug="master-data" />,
                children: [
                  {
                    path: '/master-data',
                    element: <MasterDataDashboard />,
                  },
                  {
                    path: '/master-data/roles',
                    element: <Role />,
                  },
                  {
                    path: '/master-data/cancellation-reasons',
                    element: <CancellationReasons />,
                  },
                  {
                    path: '/master-data/facility-types',
                    element: <FacilityType />,
                  },
                  {
                    path: '/master-data/qualifications',
                    element: <Qualification />,
                  },
                  {
                    path: '/master-data/document-types',
                    element: <DocumentTypes />,
                  },
                  {
                    path: '/master-data/designations',
                    element: <Designation />,
                  },
                  {
                    path: '/master-data/role-doc-mapping',
                    element: <RoleDocumentTypeMapping />,
                  },
                  {
                    path: '/master-data/facility-type-doc-mapping',
                    element: <FacilityTypeDocumentTypeMapping />,
                  },
                  {
                    path: '/master-data/banks',
                    element: <Bank />,
                  },
                  {
                    path: '/master-data/config',
                    element: <Config />,
                  },
                  {
                    path: '/master-data/bank-forms',
                    element: <BankForm />,
                  },
                  {
                    path: '/master-data/custom-forms',
                    element: <CustomForm />,
                  },
                  {
                    path: '/master-data/custom-forms/:id/manage-fields',
                    element: <ManageCustomFormFields />,
                  },
                ]
              },
              {
                path: '/search',
                element: <SearchResultsPage />,
              },
              {
                path: '/notifications',
                element: <NotificationPage />,
              },
              {
                element: <PermissionRoute moduleSlug="access-control" />,
                children: [
                  {
                    path: '/access-control/roles',
                    element: <SystemRoles />,
                  },
                  {
                    path: '/access-control/mapping',
                    element: <RoleMapping />,
                  },
                  {
                    path: '/access-control/staff',
                    element: <StaffManagement />,
                  },
                ]
              },
            ]
          },
          {
            element: <UserTypePrivateRoute allowedUserTypes={[FACILITY_USERTYPE]} />,
            children: [
              {
                path: '/facility-dashboard',
                element: <FacilityDashboard />,
              },
              {
                path: '/facility/profile',
                element: <FacilityProfilePage />,
              },
              {
                path: '/facility/shift/create',
                element: <FacilityShiftCreate />,
              }, {
                path: '/facility/shift/update/:shiftId',
                element: <FacilityShiftCreate />,
              },
              {
                path: '/facility/shifts',
                element: <FacilityShiftList />,
              },
              {
                path: '/facility/shifts/ongoing',
                element: <OngoingShifts />,
              },
              {
                path: '/facility/reports',
                element: <FacilityReport />,
              },
              {
                path: '/facility/notifications',
                element: <FacilityNotification />,
              },
              {
                path: '/facility-shift-requests',
                element: <FacilityShiftRequestsPage />,
              },
              {
                path: '/facility/invoices',
                element: <FacilityInvoice />,
              },
            ]
          },
          {
            path: '/test-push-notification',
            element: <TestPushNotificationPage />,
          }
        ],
      },
    ],
  },
]);

export default router;

